import { useQuery } from '@tanstack/react-query';
import { fetchOpenSlots } from './api';

export function useOpenSlots() {
  return useQuery({
    queryKey: ['slots', 'open'],
    queryFn: fetchOpenSlots,
  });
}
